import { Radio } from 'antd'
import classNames from 'classnames'

import cn from './AtomRadioGroup.module.scss'

export type RadioGroupOption<T extends string> = {
  value: T
  label: string
}

type RadioGroupProps<T extends string> = {
  options: RadioGroupOption<T>[]
  value: T
  onChange: (value: T) => void
  isOrganisationSelected?: boolean
  vertical?: boolean
  className?: string
}

function AtomRadioGroup<T extends string>({
  options,
  value,
  onChange,
  isOrganisationSelected = false,
  vertical = false,
  className,
}: RadioGroupProps<T>) {
  return (
    <Radio.Group
      value={value}
      onChange={(event) => {
        const option = options.find((item) => item.value === event.target.value)
        if (option) onChange(option.value)
      }}
      className={classNames(
        cn.radioGroup,
        vertical && cn.vertical,
        isOrganisationSelected && cn.radioGroupSelected,
        className
      )}
    >
      {options.map((option) => (
        <Radio key={option.value} value={option.value}>
          {option.label}
        </Radio>
      ))}
    </Radio.Group>
  )
}

export default AtomRadioGroup
